import { useRef, useEffect, useCallback } from 'react';

/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Restituisce una funzione con la stessa interfaccia di setTimeot,
 * e il timeout è automaticamente pulito all'unmont del componente.
 */
function useComponentTimeout() {
    const timeoutRef = useRef();
    useEffect(() => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
    }, []);
    const setComponentTimeout = useCallback((callback, ms, ...args) => {
        timeoutRef.current = setTimeout(callback, ms, args);
    }, []);
    return setComponentTimeout;
}

export { useComponentTimeout as default };
